// extracted by mini-css-extract-plugin
module.exports = {"bannerItem":"_3IHYR","highlight":"_2OUKt","feature":"_3CBm_","row1":"lp7O5","row2":"_1C3Th","row2SmallFont":"Igmro","row3":"_25E5n","row4":"_3uD15"};